<template>
  <div class="tags-outer-scroll" >
    <div class="label-left label-left-right icon-common">
      <i class="el-icon-arrow-left" @mousedown="handleLeftDown" @mouseup="handleLeftUp" @mouseleave="handleLeftLeave"></i>
<!--      <img class="img" src="../../../assets/label-left.png" />-->
<!--      <img class="activeImg" @mousedown="handleLeftDown" @mouseup="handleLeftUp" @mouseleave="handleLeftLeave" src="../../../assets/label-left-active.png" />-->
    </div>
    <div style="overflow: hidden"  ref="tagsOuterBox">
      <div class="tags-outer-scroll-con" :style="{left: labelLeft+ 'px'}" ref="tagsOuter">
        <!--标签按钮列表，滚动-->
        <page-tag
          class="transod" v-for="(item,index) in pageTagsList"
          @active="linkTo(item)"
          :class="{'page_tag_active':isActive(item),'nopage_tag__active':!isActive(item),'page_tag__home': item.name === 'home-index' && !isActive(item)}"
          :title="itemTitle(item)"
          @close="closePage(item)"
          :name="item.name"
          :key="item.name"
          :closeable="canTagClose(item.name)">
        </page-tag>
      </div>
    </div>
    <div class="label-right label-left-right icon-common">
      <i class="el-icon-arrow-right" @mousedown="handleRightDown" @mouseup="handleRightUp" @mouseleave="handleRightLeave"></i>
<!--      <img class="img" src="../../../assets/label-right.png" />-->
<!--      <img class="activeImg" @mousedown="handleRightDown" @mouseup="handleRightUp" @mouseleave="handleRightLeave" src="../../../assets/label-right-active.png" />-->
    </div>


      <el-popover
        popper-class="tags-popper"
        ref="popover"
        placement="bottom"
        width="20px"
        trigger="hover">
        <div class="menu-label label-move icon-common" slot="reference">
          <i class="el-icon-more-outline"></i>
<!--          <span class="menu-img"></span>-->
        </div>
        <div class="menu-label-item" @click="closeOtherTags">关闭其他</div>
        <div class="menu-label-item" @click="closeAllTab">关闭全部</div>
        <div class="menu-label-item" @click="refreshTab">刷新当前页</div>
      </el-popover>

  </div>
</template>

<script>
  import {mapState, mapActions, mapMutations} from "vuex";
  import PageTag from "./page-tag";
  import PagePutTag from "./page-put-tag";
  import {ROUTER_NAME_HOME} from "../../../router/router";
  import ClickOutsideWrapper from "../../../components/click-outside-wrapper/click-outside-wrapper";
  import ArrayUtils from "../../../libs/utils/ArrayUtils";

  export default {
    name: "page-tag-list",
    components: {
      ClickOutsideWrapper,
      PageTag,
      PagePutTag,
    },
    props: {
      shrink: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        currentPageName: this.$route.name,
        screenWidth: document.body.clientWidth,
        tabWidthList: [],//tab宽度列表
        moreMenu: false,
        menuClick: true,//是否通过菜单点击，默认为true
        ind: 1,
        timer: null,
        labelLeft: 0,
        tagsOuterWidth: 0,
        tagsOuterBoxWidth: 0,
      }
    },
    computed: {
      ...mapState("app", {
        pageTagsList: state => state.pageOpenedList,
        widthData: state => state.widthData,
      }),
      putPageTagsList() {
        return this.pageTagsList.slice(this.ind + 1);
      },
    },
    watch: {
      '$route'(to) {
        this.currentPageName = to.name;
        this.$nextTick(() => {
          if (ArrayUtils.getItemIndex(this.pageTagsList, 'name',to.name) > -1 && this.menuClick) {
            this.tagLocation(this.menuClick);
          };
          this.menuClick = true;
        })
      },

      widthData() {
        this.listeningWindow(false);
      },

      screenWidth(val) {
        this.showTabList();
      },

      shrink() {
        this.showTabList();
      },

      pageTagsList(pageTagsList, oldPageTagsList) {
        // if (pageTagsList.length !== oldPageTagsList.length) return;
        this.$nextTick(() => {
          this.listeningWindow(this.menuClick);
          this.menuClick = true;
        })
      }
    },
    inject: ['reload'], // 直接注入依赖
    methods: {
      ...mapActions("app", [
        "removeTag",
      ]),
      ...mapMutations("app", [
        "moveTagAfterHome",
        "removeLastTags",
        'removeOtherTags'
      ]),
      canTagClose(name) {
        return name !== ROUTER_NAME_HOME;
      },
      menuChange() {
        this.moreMenu = !this.moreMenu
      },
      loseFocus() {
        if (this.moreMenu) {
          this.menuChange();
        }
      },
      closeAllTab() {//关闭全部
        let pageOpenedList = this.pageTagsList;
        let item, path, name, removeNamesCount = 0, cannotCloseItem;
        for (let i = pageOpenedList.length - 1; i >= 1; i--) {
          item = pageOpenedList[i];
          path = item.fullPath;
          name = item.name;
          //lifecycleManger 允许关闭该页面
          removeNamesCount ++;
        }
        //如果某个页面关闭前的检查没通过，则把它之后允许关闭的页面全部关闭掉
        let location = { name: "home" };
        if (cannotCloseItem) {
          location = this.getLocation(cannotCloseItem);
        }

        if(this.$route.fullPath === location.path) { //如果当前页面就是关闭后需要跳转的页面只是需要移除tag
          this.removeLastTags(removeNamesCount);
        } else {
          this.$router.replace(location, () => {//如果不是则需要先跳转后再移除tag
            this.removeLastTags(removeNamesCount);
          });
        }

        this.labelLeft = 0;//将导航置最左端
      },
      closeOtherTags() {
        let pageOpenedList = this.pageTagsList;
        let item, path, name, noCloseList = [{name: "home", param: null, params: {}, path: "", query: {}, title: "首页"}], cannotCloseItem;
        for (let i = pageOpenedList.length - 1; i >= 1; i--) {
          item = pageOpenedList[i];
          path = item.fullPath;
          name = item.name;
          if(this.isActive(item)){
            noCloseList.push(item);
          }
        }
        this.removeOtherTags(noCloseList);
        this.labelLeft = 0;//将导航置最左端
      },
      //刷新当前页
      refreshTab() {
        this.reload();
      },
      itemTitle(item) {
        return item.title;
      },
      closePage(item) {
        this.menuClick = false;
        let name = item.name;
        let pageOpenedList = this.pageTagsList;
        let lastPageObj = pageOpenedList[0];
        //如果关闭的是当前打开的页面，则需要路由转到最近的一个页面
        if (this.currentPageName === name) {
          let len = pageOpenedList.length;
          for (let i = 1; i < len; i++) {
            if (pageOpenedList[i].name === name) {
              if (i < (len - 1)) {
                lastPageObj = pageOpenedList[i + 1];
              } else {
                lastPageObj = pageOpenedList[i - 1];
              }
              break;
            }
          }
          let location = this.getLocation(lastPageObj);
          this.internalNavigate(location, () => {
            this.removeTag(name);
          });
        } else {
          this.removeTag(name);
        }
      },
      linkTo(item, insert) {
        let location = this.getLocation(item);
        this.menuClick = false;
        this.internalNavigate(location, () => {
          if (insert) {
            this.moveTagAfterHome(item);
          }
        });
      },
      isSelect(item) {
        this.moveTagAfterHome(item);
      },

      getLocation(item) {
        let location = {};
        location.name = item.name;
        if (item.argu) {
          location.params = item.argu;
        }
        if (item.query) {
          location.query = item.query;
        }
        return location;
      },


      internalNavigate(targetLocation, callback) {
        this.$router.push(targetLocation, callback);
      },

      isActive(item) {
        let routeName = this.currentPageName;
        if (item.children) {
          return item.children[0].name === routeName;
        } else {
          return item.name === routeName;
        }
      },
      showTabList() {
        let surWidth = this.screenWidth - 60 - 160 - 12;
        this.ind = Math.floor(surWidth / 161) - 1;
      },

      //左滚动标签
      // handleLeftClick() {
      //   if (this.labelLeft < 0) {
      //     let left = 0;
      //     let len = this.tabWidthList.length;
      //     for (let i = 0; i < len; i++) {
      //       if (this.labelLeft + left + this.tabWidthList[i] >= 0){
      //         break;
      //       }
      //       left += this.tabWidthList[i];
      //     };
      //     this.labelLeft = -left;
      //   }else {
      //     return
      //   }
      // },
      handleLeftDown() {
        let that = this;
        this.timer = setInterval(() => {
          if (that.labelLeft < 0) {
            let left = 0;
            let len = that.tabWidthList.length;
            for (let i = 0; i < len; i++) {
              if (that.labelLeft + left + that.tabWidthList[i] >= 0){
                break;
              }
              left += that.tabWidthList[i];
            };
            that.labelLeft = -left;
          }
        },350);
      },
      handleLeftLeave() {
        clearInterval(this.timer);
      },
      handleLeftUp() {
        if (this.labelLeft < 0) {
          let left = 0;
          let len = this.tabWidthList.length;
          for (let i = 0; i < len; i++) {
            if (this.labelLeft + left + this.tabWidthList[i] >= 0){
              break;
            }
            left += this.tabWidthList[i];
          };
          this.labelLeft = -left;
        }
        clearInterval(this.timer);
      },
      //右滚动标签
      handleRightDown() {
        let that = this;
        this.timer = setInterval(() => {
          if (that.tagsOuterWidth - that.tagsOuterBoxWidth + that.labelLeft > 0) {
            let left = 0;
            let len = that.tabWidthList.length;
            for (let i = 0; i < len; i++) {
              if (left - that.tagsOuterBoxWidth + that.labelLeft > 0){
                break;
              }
              left += that.tabWidthList[i];
            };
            that.labelLeft = this.tagsOuterBoxWidth - left;
          }
        },350);
      },
      handleRightLeave() {
        clearInterval(this.timer);
      },
      handleRightUp() {
        if (this.tagsOuterWidth - this.tagsOuterBoxWidth + this.labelLeft > 0) {
          let left = 0;
          let len = this.tabWidthList.length;
          for (let i = 0; i < len; i++) {
            if (left - this.tagsOuterBoxWidth + this.labelLeft > 0){
              break;
            }
            left += this.tabWidthList[i];
          };
          this.labelLeft = this.tagsOuterBoxWidth - left;
        }
        clearInterval(this.timer);
      },
      //tag定位
      tagLocation(menuClick) {
        if (this.tagsOuterBoxWidth > this.tagsOuterWidth || !menuClick) return;
        let index = ArrayUtils.getItemIndex(this.pageTagsList, 'name',this.currentPageName);
        let tagWidth = 0;
        for (let i = 0; i < index + 1; i++) {
          tagWidth += this.tabWidthList[i];
        };
        let left = tagWidth - this.tagsOuterBoxWidth;

        if (this.labelLeft + tagWidth <= 0 ) {
          this.labelLeft = -(tagWidth - this.tabWidthList[index])
        }else if (left > 0) {
          this.labelLeft = -left;
        }
      },

      listeningWindow(type) {
        let tabList = Array.from(this.$refs.tagsOuter.children);
        this.tabWidthList = tabList.map((item) => {
          let width = window.getComputedStyle(item).width;
          return Number(width.replace(/px/g,'')) + 64;
        });
        this.tagsOuterWidth = parseFloat(window.getComputedStyle(this.$refs.tagsOuter).width);
        this.tagsOuterBoxWidth = parseFloat(window.getComputedStyle(this.$refs.tagsOuterBox).width);
        if (this.labelLeft < this.tagsOuterBoxWidth - this.tagsOuterWidth ){
          if (this.tagsOuterBoxWidth > this.tagsOuterWidth){
            this.labelLeft = 0;
          }else{
            this.labelLeft = this.tagsOuterBoxWidth - this.tagsOuterWidth;
          }
        } else {
          this.labelLeft = 0;
        }
        this.tagLocation(type);
      },

    },

    mounted() {
      this.$nextTick(() => {
        this.listeningWindow(false);
      })
    },
  }
</script>

<style lang="scss">
  $linkColor: #DDDDDD;

  .tags-outer-scroll{
    float: left;
    width: calc(100% - 116px);
    padding-left: 46px;
    padding-right: 70px;
    position: relative;
    .icon-common:hover{
      background: #ffffff;
      color: #215DE8;
      font-weight: 600;
    }
    .label-left{
      left: 12px;
      .activeImg{
        display: none;
      }
    }
    //.label-left:hover .img{
    //  display: none;
    //}
    //.label-left:hover .activeImg{
    //  display: inline-block;
    //}
    .label-right{
      right: 50px;
      .activeImg{
        display: none;
      }
    }
    //.label-right:hover .img{
    //  display: none;
    //}
    //.label-right:hover .activeImg{
    //  display: inline-block;
    //}
    .menu-label{
      right: 14px;
      .menu-img{
        display: inline-block;
        height: 100%;
        width: 100%;
        background: url("../../../assets/menu.png");
      }
    }
    .menu-label:hover .menu-img{
      background: url("../../../assets/menu-active.png");
    }
    .label-move{
      cursor: pointer;
      position: absolute;
      height: 40px;
      line-height: 40px;
      width: 32px;
      top: 0;
      text-align: center;
      background: #E8EAED;
      color: #CBCFD6;
    }
    .label-left-right{
      cursor: pointer;
      position: absolute;
      height: 40px;
      line-height: 40px;
      width: 32px;
      text-align: center;
      top: 0;
      background: #E8EAED;
      color: #CBCFD6;
    }
  }
  .tags-outer-scroll-con {
    position: relative;
    /*box-sizing: border-box;*/
    /*width: 100%;*/
    z-index: 100;
    height: 40px;
    white-space:nowrap;
    display: inline-block;
    transition: all .3s;
  }

  .transod {
    margin: 0 2px;
    padding: 0 30px;
    height: 40px;
    line-height: 40px;
    box-sizing: border-box;
    cursor: pointer;
    position: relative;
  }
  .close-icon{
    display: none;
    position: absolute;
    right: 8px;
    top: 13px;
    height: 14px;
    width: 14px;
    font-size: 14px;
  }
  .page_tag_active {
    background: #ffffff;
    color: #215DE8;
    font-weight: 600;
    .close-icon {
      display: block;
      color: #A9AEBB;
    }
  }

  .nopage_tag__active {
    font-weight: 400;
    background: #E8EAED;
    color: #70798E;
  }

  .page_tag__home{
    color: #5398F7;
  }

  .more-menu-change {
    width: 40px;
    height: 38px;
    position: fixed;
    background: white;
    right: 0px;
    li {
      height: 40px;
      line-height: 40px;
    }
    .icon-more-menu {
      padding-top: 15px;
      box-sizing: border-box;
      .triangle {
        width: 0;
        height: 0;
        margin: 0 auto;
        /*margin-top: 10px;*/
        border-top: 9px solid #515151;
        border-left: 6px solid transparent;
        border-right: 6px solid transparent;
      }
    }
    .child-more-menu {
      text-align: center;
      margin-left: -20px;
      width: 130px;
      right: 70px;

      z-index: 40000;
      background: white;
      box-shadow: rgba(0, 0, 0, 0.09) 1px 0 1px 1px;
      border-radius: 4px;
      > li {
        font-size: 14px;
        font-weight: 500;
      }
      > li:hover {
        background: #E6E6E6;
        color: #5398F7;
      }
    }
  }
  .page_put_tag_active {
    color: #5398F7;
  }
  .tags-popper{
    min-width: 0;
    .menu-label-item{
      text-align: center;
      width: 80px;
      height: 20px;
      line-height: 20px;
      background: #FFFFFF;
      color: #999999;
      border-radius: 5px;
      cursor: pointer;
    }
    .menu-label-item:hover{
      background: #5398F7;
      color: #FFFFFF;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/components/PageTagList/page-tag-list.vue